<p-confirmdialog></p-confirmdialog>

<app-card-content [border]="false" icon="pi pi-history" title="Anotações" subtitle="Histórico de anotações do médico">
    <div card-header>
        @if (podeExibirAcoesGerais()) {
            <p-button icon="pi pi-plus-circle" (click)="abrirDialogNovaAnotacao()" [text]="false" [rounded]="false" [label]="'Adicionar'" [tooltipPosition]="'left'" [pTooltip]="'Nova Anotação'" [appCan]="roleCriar()"></p-button>
        }
    </div>

    <div class="anotacoes-corpo">
        <div class="flex justify-between items-center">
            <div class="mx-auto">
                <p-selectbutton [options]="options" [ngModel]="selectedValue" (ngModelChange)="onChange($event)" optionLabel="label" optionValue="value" [unselectable]="true" class="flex flex-wrap justify-center gap-2" styleClass="w-33">
                    <ng-template let-option pTemplate="item">
                        <div class="flex items-center">
                            <span>{{ option.label }}</span>
                        </div>
                    </ng-template>
                </p-selectbutton>
            </div>
        </div>

        <!-- Filtros -->
        <app-filtros-bar class="mt-4" (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
            <app-filtro-campo label="Texto da Anotação" [wide]="true" inputId="anotacoes-filtro-texto">
                <input id="anotacoes-filtro-texto" pInputText type="text" class="w-full" [ngModel]="filtroTexto()" (ngModelChange)="filtroTexto.set($event)" (keyup.enter)="aplicarFiltros()" placeholder="Buscar no histórico..." />
            </app-filtro-campo>
        </app-filtros-bar>

        <app-custom-table
            [data]="linhasFiltradas()"
            [metadata]="tableMetadata()"
            [loading]="loading()"
            [totalRecords]="totalRecords()"
            [first]="first()"
            [rows]="rows()"
            [initialViewMode]="initialViewMode()"
            [sortState]="sortState()"
            [useCustomCard]="true"
            [cardColumns]="4"
            actionsColumnLabel="Ações"
            (onPageChange)="onPageChange($event)"
            (sortData)="onSortData($event)"
        >
            <ng-template pTemplate="card" let-rowData>
                <app-card-container [hoverEfect]="true">
                    <div class="indicador-topo">
                        <div class="flex items-center gap-2">
                            <p-badge [value]="selectedLabel" badgeSize="large" [severity]="getStatusSeverity()"></p-badge>
                        </div>
                        <div class="indicador-contagem">
                            <div class="indicador-valor">{{ rowData.data || 'N/A' }}</div>
                            <div class="indicador-label">Data</div>
                        </div>
                    </div>

                    <h3 class="indicador-titulo">Anotação</h3>

                    <div class="mt-3 text-xs leading-relaxed text-surface-700 dark:text-surface-200 line-clamp-4" [pTooltip]="rowData.historico" tooltipPosition="left">
                        {{ obterHistoricoExibicao(rowData) }}
                    </div>

                    @if (tableMetadata().actions) {
                        <div class="flex justify-end items-center mt-4 pt-3 border-t border-surface-200 dark:border-surface-700">
                            <div class="flex gap-1">
                                @for (action of tableMetadata().actions | keyvalue; track action.key) {
                                    <p-button
                                        [icon]="action.value.icon"
                                        [text]="true"
                                        [rounded]="true"
                                        size="small"
                                        [severity]="action.value.color"
                                        [pTooltip]="action.value.label"
                                        tooltipPosition="left"
                                        [ariaLabel]="action.value.label + ' anotação de ' + rowData.data"
                                        (click)="action.value.command(rowData); $event.stopPropagation()"
                                    ></p-button>
                                }
                            </div>
                        </div>
                    }
                </app-card-container>
            </ng-template>
        </app-custom-table>
    </div>
</app-card-content>

<p-dialog appDialogoPadrao="pi pi-info-circle" descricao="Anotação registrada no cadastro." header="Visualizar anotação" [(visible)]="modalVisualizacaoAnotacao" [style]="{ width: '42rem', maxWidth: '95vw' }" (onHide)="fecharVisualizacaoAnotacao()">
    @if (anotacaoVisualizacao(); as anotacao) {
        <section class="anotacao-dialog">
            <div class="anotacao-dialog-data">
                <span class="anotacao-dialog-label">Data</span>
                <strong>{{ anotacao.data || 'Não informada' }}</strong>
            </div>

            <div class="anotacao-dialog-texto">
                <span class="anotacao-dialog-label">Anotação</span>
                <p>{{ anotacao.historico || 'Sem texto informado.' }}</p>
            </div>
        </section>
    }

    <ng-template pTemplate="footer">
        <p-button label="Fechar" icon="pi pi-times" severity="secondary" (onClick)="fecharVisualizacaoAnotacao()"></p-button>
    </ng-template>
</p-dialog>

<app-anotacao-nova [(showDialog)]="modalNovaAnotacao" [pessoa]="pessoa()" [salvando]="loading()" (anotacaoCriada)="onAnotacaoCriada($event)" />
